<template>
  <div style="display: flex; flex-direction: column">
    <div v-show="!disabled" style="padding: 5px 0">
      <el-button type="primary" @click="showEditDialog(true)">{{ $t("SeaExport.Add") }}</el-button>
      <el-button type="primary" @click="showEditDialog(false)">{{ $t("SeaExport.Edit") }}</el-button>
      <el-button type="danger" @click="remove">{{ $t("SeaExport.Delete") }}</el-button>
    </div>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width: 100%; height: 350px"
      @gridReady="(params) => { gridApi = params.api }"
    />
    <div style="padding: 5px 0; font-size: 12px">
      <span style="color: #0a0aff">{{ $t("SeaExport.freightChargesUSDTotal") }}</span>
      <i style="margin-left: 15px; margin-right: 5px">{{ cargoDoc.freightChargeEnUpper }}</i>
      <i>({{ NumberUtils.formatNumber(cargoDoc.freightChargeTotal, 2) }})</i>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="465px"
      :close-on-click-modal="false"
      class="freight-charges-info-dialog"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('SeaExport.ChargeItem')">
            <cargo-advance-select
              no="chargeItemId"
              :select-type="TYPE_NAMES.basic_data_ChargeItem"
              filterable
              :default-value="editDialog.form.chargeItemId||''"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.chargeItemId=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargeClause')">
            <cargo-advance-select
              no="paymentTermHBL"
              :select-type="TYPE_NAMES.basic_data_PaymentTerm"
              filterable
              :default-value="editDialog.form.paymentTermHBL"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.paymentTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Currency')">
            <cargo-advance-select
              no="currency"
              :select-type="TYPE_NAMES.basic_data_Currency"
              filterable
              :default-value="editDialog.form.currency"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.currency=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <cargo-advance-select
              no="eqSize"
              :select-type="TYPE_NAMES.local_cache_EQSize"
              :headers="[$t('SeaExport.Code2')]"
              :fields="['code']"
              filterable
              :default-value="editDialog.form.eqSize"
              tag-name="code"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqSize=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerType')">
            <cargo-advance-select
              no="eqType"
              :select-type="TYPE_NAMES.basic_data_EQType"
              :headers="[$t('SeaExport.Code2')]"
              :fields="['code']"
              filterable
              :default-value="editDialog.form.eqType"
              tag-name="code"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Quantity2')">
            <el-input-number
              v-model="editDialog.form.quantity"
              no="quantity"
              :precision="0"
              :controls="false"
              style="width:100%"
              @change="p => {caculateAmount(); changeBillOfLadingSynJob()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UnitRate')">
            <el-input-number
              v-model="editDialog.form.unitRate"
              no="unitRate"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="caculateAmount"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Amount')">
            <el-input-number
              v-model="editDialog.form.amount"
              no="amount"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="editDialog.form.unitRate=editDialog.form.amount"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { FreightCharges } from '@/class/model/booking/FreightCharges'
import * as NumberUtils from '@/utils/NumberUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import StrUtils from '@/utils/StrUtils'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'

export default {
  name: 'SeHblFreightChargesInfo',
  components: {
    cargoAdvanceSelect
  },
  props: {
    job: { type: Object, default: () => {} },
    cargoDoc: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      TYPE_NAMES,
      NumberUtils,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 145,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        }, {
          headerName: this.$t('SeaExport.ChargeClause'),
          colId: 'paymentTermHBL',
          field: 'paymentTermHBL',
          width: 145
        }, {
          headerName: this.$t('SeaExport.Currency'),
          colId: 'currency',
          field: 'currency',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          width: 145
        }, {
          headerName: this.$t('SeaExport.Quantity2'),
          colId: 'quantity',
          field: 'quantity',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.UnitRate'),
          colId: 'unitRate',
          field: 'unitRate',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Amount'),
          colId: 'amount',
          field: 'amount',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      editDialog: {
        visible: false,
        title: '',
        form: new FreightCharges().fillDefaultValue().getData()
      }
    }
  },
  computed: {
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  watch: {
    cargoDoc: {
      immediate: true,
      async handler() {
        if (this.cargoDoc.freightCharges === null) {
          this.cargoDoc.freightCharges = ''
        }
        const freightCharges = await new SeaCargoDoc(this.cargoDoc).getFreightCharges()
        this.rowData = freightCharges
      }
    }
  },
  methods: {
    showEditDialog(isNew) {
      if (isNew) {
        const newRow = new FreightCharges().fillDefaultValue().getData()
        newRow.cargoDocUuid = this.cargoDoc.uuid
        this.editDialog.form = newRow
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.finalRowData[cell.rowIndex] : undefined
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (!row.seq) {
          row.seq = this.autoIncrementNum.getNextNum()
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    caculateAmount() {
      const form = this.editDialog.form
      form.amount = (form.quantity || 0) * (form.unitRate || 0)
    },
    changeBillOfLadingSynJob() {
      CargoDocUtil.changeBillOfLadingSynJob(this.job, this.cargoDoc, false)
    },
    save() {
      const form = this.editDialog.form
      if (!form.seq) {
        this.rowData.push(form)
        setTimeout(() => {
          this.gridApi.setFocusedCell(this.finalRowData.length - 1)
        }, 100)
      } else {
        const row = this.rowData.find(p => p.seq === form.seq)
        if (row) {
          Object.assign(row, form)
          this.gridApi.refreshCells({ force: true })
        }
      }
      this.refershFreightChargeTotal()
      this.editDialog.visible = false
    },
    refershFreightChargeTotal() {
      let totalAmount = 0
      for (const charge of this.finalRowData) {
        if (charge.currency === 'USD') { // USD
          totalAmount += charge.amount
        }
      }
      this.cargoDoc.freightChargeTotal = totalAmount
      this.cargoDoc.freightChargeEnUpper = StrUtils.jsdx2(totalAmount)
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.finalRowData[cell.rowIndex] : undefined
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (row.uuid) {
        row.deleted = true
        /* 强制刷新finalRowData */
        const tempRowData = this.rowData
        this.rowData = []
        this.$nextTick(() => {
          this.rowData = tempRowData
        })
      } else {
        const index = this.rowData.findIndex(p => p === row)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      }
      this.refershFreightChargeTotal()
    }
  }
}
</script>

<style lang="scss" scoped>
.freight-charges-info-dialog::v-deep {
  .el-input-number .el-input input {
    text-align: right;
  }
}
</style>
